query UsageData(
    $daysAmountFilter: ConditionInt
    $daysAmountx2Filter: ConditionInt
    $textSearch: wsdk_test_runsSearchInsensitive
    $textSearchExact: wsdk_test_runsSearchInsensitive
) {
    last_n_days: wsdk_test_runs(
        run_time_last_n_days: $daysAmountFilter,
        text_contains: $textSearch,
        text_equals: $textSearchExact
    ) {
		run_id_count
		total_pages_sum
	}
    last_2n_days: wsdk_test_runs(
        run_time_last_n_days: $daysAmountx2Filter,
        text_contains: $textSearch,
        text_equals: $textSearchExact
    ) {
		run_id_count
		total_pages_sum
	}
}

query RecentUsageData(
    $daysAmountFilter: ConditionInt
    $daysAmountx2Filter: ConditionInt
    $textSearch: wsdk_latest_test_runsSearchInsensitive
    $textSearchExact: wsdk_latest_test_runsSearchInsensitive
) {
    last_n_days: wsdk_latest_test_runs(
        run_time_last_n_days: $daysAmountFilter,
        text_contains: $textSearch,
        text_equals: $textSearchExact
    ) {
		run_id_count
		total_pages_sum
	}
    last_2n_days: wsdk_latest_test_runs(
        run_time_last_n_days: $daysAmountx2Filter,
        text_contains: $textSearch,
        text_equals: $textSearchExact
    ) {
		run_id_count
		total_pages_sum
	}
}
